/* eslint-disable react/no-unstable-nested-components */
import React from 'react';
import { Box } from '@chakra-ui/react';
import { DataGrid } from '../../components/datagrid';
import { SearchFilter } from '../../components/inputs/filters/search';
import { SelectFilter } from '../../components/inputs/filters/select';
import { PageTitle } from '../../components/PageTitle';
import { useFetch } from '../../hooks/useFetch';
import { getCellImage, getCellStatus } from '../../utils/FormatFunctions';

export function UsersPage() {
  const baseApiUrl = '/v1/admin';
  const baseUrl = `${baseApiUrl}/users`;
  const { requestApi, data, loading, error } = useFetch(baseUrl);
  const { requestApi: reqApiGroup, data: dataGroups } = useFetch(`${baseApiUrl}/groups`);

  const columns = [
    { name: 'id', label: 'Id' },
    { name: 'image', label: 'Imagem' },
    { name: 'name', label: 'Nome' },
    { name: 'email', label: 'Email' },
    { name: 'group.name', label: 'Grupo' },
    { name: 'status', label: 'Status' },
  ];

  return (
    <Box>
      <PageTitle>Usuários</PageTitle>

      <DataGrid
        columns={columns}
        rows={data?.data}
        requestApi={requestApi}
        error={error}
        baseUrl={baseUrl}
        data={data}
        hasCreate
        loading={loading}
        rowActions={{ show: false, edit: true, delete: true }}
        formatColum={[
          {
            field: 'image',
            formatField: (values) => getCellImage(values, true),
          },
          {
            field: 'status',
            formatField: getCellStatus,
          },
        ]}
        headerFilters={[
          {
            name: 'search',
            filterComponent: SearchFilter,
          },
          {
            name: 'group_id',
            filterComponent: SelectFilter,
            placeholder: 'Selecionar grupo',
            isSearchable: true,
            onInputChange: (value) => {
              reqApiGroup('get', { params: { search: value } });
            },
            options: [
              ...(dataGroups?.data?.map((item) => ({
                label: item?.name,
                value: item?.id,
              })) ?? []),
            ],
          },
          // {
          //   name: 'institution_id',
          //   filterComponent: SelectFilter,
          //   placeholder: 'Selecionar instituição',
          //   isSearchable: true,
          //   onInputChange: value => {
          //     reqApiInstitution('get', { params: { search: value } });
          //   },
          //   options: [
          //     ...(dataInstitution?.data?.map(item => ({
          //       label: item?.name,
          //       value: item?.id,
          //     })) ?? []),
          //   ],
          // },
        ]}
      />
    </Box>
  );
}
